<template>
  <div class="setting-page">
    <Form :label-width="100">
      <div class="fielset">
        <h3>{{$t('setting.Basic_Information')}}</h3>
        <FormItem :label="$t('setting.username')">
            <Input class="info" v-model="username" disabled></Input>
        </FormItem>
        <FormItem :label="$t('setting.name')">
            <Input class="info" v-model="name" :placeholder="$t('setting.please_enter')"></Input>
        </FormItem>
      </div>
      <div class="fielset">
        <h3>{{$t('setting.company_information')}}</h3>
        <FormItem :label="$t('setting.company')">
            <Input class="info" v-model="company" disabled></Input>
        </FormItem>
        <FormItem :label="$t('setting.workNo')">
            <Input class="info" v-model="workNo" disabled></Input>
        </FormItem>
        <!-- <FormItem :label="$t('setting.department')">
            <Input class="info" v-model="department" disabled></Input>
        </FormItem> -->
        <!-- <FormItem :label="$t('setting.workPosition')">
            <Input class="info" v-model="workPosition" disabled></Input>
        </FormItem> -->
        <FormItem :label="$t('setting.role')">
            <Input class="info" v-model="role" disabled></Input>
        </FormItem>
      </div>
      <div class="fielset">
        <h3>{{$t('setting.Contact_information')}}</h3>
        <FormItem :label="$t('setting.phone')">
            <Input class="info" v-model="phone" :placeholder="$t('setting.please_enter')"></Input>
        </FormItem>
        <FormItem :label="$t('setting.eMail')">
            <Input class="info" v-model="eMail" :placeholder="$t('setting.please_enter')"></Input>
        </FormItem>
        <FormItem :label="$t('setting.qq')">
            <Input class="info" v-model="qq" :placeholder="$t('setting.please_enter')"></Input>
        </FormItem>
        <FormItem :label="$t('setting.wechat')">
            <Input class="info" v-model="wechat" :placeholder="$t('setting.please_enter')"></Input>
        </FormItem>
      </div>
      <div class="fielset">
        <h3>{{$t("setting.System_setting")}}</h3>
        <FormItem :label="$t('setting.language')">
            <Select class="info" v-model="language" :value="language" @on-change="Changelanguage">
              <Option value="zh-cn" key="zh-cn">{{$t('setting.zhcn')}}</Option>
              <Option value="en-US" key="en-US">{{$t('setting.enUS')}}</Option>
              <Option value="zh-tw" key="zh-tw">{{$t('setting.zhtw')}}</Option>
              <Option value="ja-JP" key="ja-JP">{{$t('setting.jaJP')}}</Option>
              <Option value="vi-VN" key="vi-VN">{{$t('setting.viVN')}}</Option>
              <Option value="th-TH" key="th-TH">{{$t('setting.thTH')}}</Option>
            </Select>
        </FormItem>
        <FormItem>
          <qriously :value="qr" :size="200" :backgroundAlpha="1"/>
        </FormItem>
        <!-- <FormItem :label="$t('system.SystemInfo.warnLimitTime')">
            <Input class="info" v-model="warnLimitTime" :placeholder="$t('system.SystemInfo.please_enter')"></Input>
        </FormItem> -->
      </div>
      <hr>
      <div class="save-btn"><Button type="primary" @click="save()">{{$t('setting.save')}}</Button></div>
    </Form>
  </div>
</template>
<script>
import {Api} from '@/api'
export default {
  name: 'Setting',
  data () {
    return {
      username: '',
      qr: '',
      name: '',
      workNo: '',
      department: '0',
      workPosition: '',
      role: '',
      phone: '',
      eMail: '',
      qq: '',
      wechat: '',
      company: '',
      departmenID: '',
      roleID: '',
      id: 0,
      language: ''
    }
  },
  methods: {
    save () {
      let account
      account = {
        id: this.id,
        username: this.username,
        name: this.name,
        workNo: this.workNo,
        department: Number(this.departmentID),
        role: Number(this.roleID),
        phone: this.phone,
        eMail: this.eMail,
        qq: this.qq,
        wechat: this.wechat,
        language: this.language
      }
      Api.account.save(account).then(() => {
        this.$router.push({'name': 'Index'})
      })
    },
    Changelanguage (v) {
      localStorage.language = v
      this.$i18n.locale = v
    }
  },
  mounted () {
    // Api.department.list().then(res => {
    //   this.departmentlist = res.departments
    // })
    // Api.role.list().then(res => {
    //   this.rolelist = res.roles
    // })
  },
  beforeRouteEnter (to, from, next) {
    Api.user.fetchUserInfo().then(res => {
      next(vm => {
        vm.id = res.user.id
        vm.username = res.user.username
        vm.name = res.user.name
        Api.account.get(vm.id).then(res1 => {
          vm.workNo = res1.account.workNo
          vm.phone = res1.account.phone
          vm.eMail = res1.account.eMail
          vm.qq = res1.account.qq
          vm.wechat = res1.account.wechat
          vm.roleID = res1.account.role
          // vm.departmenID = res1.account.department
          Api.role.get(res1.account.role).then(res2 => {
            vm.role = res2.role.name
          })
          // Api.department.get(res1.account.department).then(res3 => {
          //   vm.department = res3.department.name
          // })
          Api.system.get(res1.account.company).then(res3 => {
            vm.company = res3.company.name
          })
          vm.language = res1.account.language
          vm.qr = res1.account.username + ',' + res1.account.password + ',' + res1.account.systemcode
        })
      })
    })
  }
}
</script>
<style scoped>
  .setting-page {
    padding: 10px;
    padding-left: 20px;
  }
  .fielset .info {
    width: 33.3333%;
  }
  .save-btn {
    text-align: left;
  }
  hr {
    background-color: #dbdbdb;
    border: none;
    display: block;
    height: 1px;
    margin: 1.5rem 0;
  }
</style>



// WEBPACK FOOTER //
// Setting.vue?2ce05666